import _ from 'lodash';
import cx from 'classnames';
import { observer } from 'mobx-react';

/* eslint-disable no-unused-vars */
const HeroPhotoAndInfoBar = observer(
  ({
    brandPartner,
    dollarsDonatedOverride,
    dollarsRaisedOverride,
    fundraisedAmount,
    heroPhotoUrl,
    hideImpactStats,
    lifetimeImpact,
    lifetimeImpactCurrencyUnit,
    lifetimeImpactOverride,
    peopleServed,
    peopleServedOverride,
    showDollarsDonatedOverride,
    showDollarsRaisedOverride,
    showFundraisedAmount,
    showLifetimeImpact,
    showLifetimeImpactOverride,
    showPeopleServed,
    showPeopleServedOverride,
  }) => {
    const peopleServedImpactStats = ['peopleServed', 'peopleServedOverride'];

    const impactStats = [
      'lifetimeImpact',
      'fundraisedAmount',
      'dollarsDonatedOverride',
      'dollarsRaisedOverride',
      'lifetimeImpactOverride',
    ];

    const stats = peopleServedImpactStats.concat(impactStats);

    const isEmptyStat = (stat) => {
      const value = eval(stat);
      return !value || value.length == 0 || parseInt(value) == 0;
    };

    const formattedStatDescription = (stat) =>
      _.startCase(stat)
        .toLowerCase()
        .replace('override', '')
        .replace('fundraised amount', 'fundraised')
        .replace('people served', 'lives impacted');

    const showStat = (stat) => eval(_.camelCase(`show-${stat}`));

    const isVisibleImpactStatsPresent = () =>
      _.find(stats, (stat) => {
        if (!isEmptyStat(stat) && showStat(stat)) {
          return true;
        }
      });

    return (
      <div className='relative flex items-center'>
        <div
          className='hero-photo flex-auto bg-cover bg-center lg-rounded w-full'
          style={{ backgroundImage: `url(${heroPhotoUrl})` }}
        />

        <div className='max-w-xs mx-auto md-absolute md-bottom-0 md-max-w-full md-w-full show-for-large-up lg-rounded-b'>
          {!hideImpactStats && isVisibleImpactStatsPresent() && (
            <div className='teams-info-bar -mt-2 mx-2 px-1 bg-cw-white text-center text-cw-black relative z-20 py-4 lg-mx-auto lg-rounded-b'>
              <p className='label-2xs mb-2'>Our impact</p>
              <div className='md-flex'>
                {stats.map(
                  (stat) =>
                    !isEmptyStat(stat) &&
                    showStat(stat) && (
                      <div
                        className={cx(
                          `${_.kebabCase(
                            stat
                          )} mx-2 flex-1 md-pr-1 md-mr-1 md-ml-0`,
                          { 'team-lti': stat == 'lifetimeImpact' }
                        )}
                        key={stat}
                      >
                        <p className='p10 font-heading'>
                          {impactStats.includes(stat) && (
                            <sup className='font-sans text-xs'>
                              {lifetimeImpactCurrencyUnit}
                            </sup>
                          )}
                          {eval(stat)}
                        </p>
                        <div className='text-grey-40 text-xs'>
                          {formattedStatDescription(stat)}
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
);
/* eslint-enable no-unused-vars */

export default HeroPhotoAndInfoBar;
